import React from 'react';

import NormalView from './view';
import MiniView from './mobile';

const Component = ({ props }) =>
  (window.innerWidth >= 1024) ? <NormalView id={props._id} /> : <MiniView id={props._id} />;

export default Component;
